/* DON'T EDIT THIS FILE: edit original and run build again */ import firebase from "firebase/compat/app";

export const setupFirestoreOptions = () => {
  firebase.firestore().settings({
    ignoreUndefinedProperties: true,
    merge: true,
  });
};
